module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-presenter-container",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": "card-presenter-toggle"
    },
    on: {
      "after-leave": _vm.afterHidden
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "card-presenter",
    on: {
      "click": function($event) {
        _vm.stopClickPropagation($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-image-container"
  }, [(_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('a', {
    staticClass: "prev-next-button prev",
    on: {
      "click": function($event) {
        _vm.scrollProfile('left')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left align-arrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.presentation.props.PresenterInfo) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.presentation.props.PresenterInfo.pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : (_vm.presentation.props.PresenterProfiles) ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].pictureURL,
      "onerror": "this.onerror = \"null\"; this.src = \"/static/img/anonymous.svg\""
    }
  }) : _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": require("../assets/icons/anonymous.svg")
    }
  }), _vm._v(" "), (_vm.presentation.props.PresenterProfiles && _vm.presentation.props.PresenterProfiles.profiles.length > 1) ? _c('a', {
    staticClass: "prev-next-button next",
    on: {
      "click": function($event) {
        _vm.scrollProfile('right')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right align-arrow"
  })]) : _vm._e()]), _vm._v(" "), (_vm.presentation.props.PresenterInfo) ? _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterInfo.displayName))]) : (_vm.presentation.props.PresenterProfiles) ? _c('h5', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].displayName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link-collection"
  }, [(_vm.presentation.props.PresenterInfo) ? _c('div', {
    staticClass: "card-links"
  }, _vm._l((_vm.presentation.props.PresenterInfo.items), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('presenterLink', {
      attrs: {
        "item": item
      }
    })], 1)
  })) : (_vm.presentation.props.PresenterProfiles) ? _c('div', {
    staticClass: "card-links"
  }, _vm._l((_vm.presentation.props.PresenterProfiles.profiles[_vm.profileIndex].items), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('presenterLink', {
      attrs: {
        "item": item
      }
    })], 1)
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-presenter-footer"
  }, [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Close')))])]), _vm._v(" "), _c('a', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71427c20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PresenterCard.vue
// module id = 478
// module chunks = 0